import './dialog.scss';
import A11yDialog from 'a11y-dialog';

const dialogElement = document.querySelector('#dialog');
const dialogContentElement = document.querySelector('#dialog-content');
const dialogTitleElement = document.querySelector('#dialog-title');
const dialog = new A11yDialog(dialogElement);

// Animation
function handleAnimation(show = false) {
	if (show) {
		dialog.$el.classList.add('is-shown');

		document.documentElement.classList.add('has-dialog');
	} else {
		dialog.$el.classList.add('is-hiding');
	}

	const onEnd = () => {
		if (!show) {
			dialog.role = 'dialog';

			dialog.$el.classList.remove('is-shown');
			dialog.$el.classList.remove('is-hiding');
			dialog.$el.classList.remove('is-small');

			document.documentElement.classList.remove('has-dialog');
		}

		// dialog.$el.removeEventListener('transitionend', onEnd);
	};

	// dialog.$el.addEventListener('transitionend', onEnd);

	// Transitionend not working properly
	setTimeout(onEnd, 300);
}

dialog.on('show', () => handleAnimation(true)).on('hide', () => handleAnimation());

class Dialog {
	constructor() {
		this.dialog = dialog;
	}

	toggle(element, show = false, options) {
		if (!show) {
			dialog.hide();

			return;
		}

		this.show(element, options);
	}

	show(element, options = {}) {
		if (element) {
			const persistanceId = options.persistanceId ? `dialog-${options.persistanceId}` : null;

			if (persistanceId && window.localStorage.getItem(persistanceId) === 'true') {
				return;
			}

			this.element = element;
			this.parent = element.parentNode;

			dialogContentElement.innerHTML = '';
			dialogContentElement.append(element);

			dialogContentElement.querySelectorAll('[data-dialog="hide"]').forEach(hideElement => {
				hideElement.addEventListener('click', event => {
					event.preventDefault();

					const persist = !!hideElement.dataset.dialogPersist;

					if (persist) {
						window.localStorage.setItem(persistanceId, 'true');
					}

					dialog.hide();
				});
			});
		}

		dialogTitleElement.innerHTML = options.title || 'Infos';

		if (options.modal) {
			dialog.$el.classList.add('is-modal');

			dialog.role = 'alertdialog';
		}

		dialog.show();

		if (options.onClose) {
			const close = () => {
				options.onClose();

				dialog.off('hide', close);
			};

			dialog.on('hide', close);
		}
	}

	hide() {
		// Put element back to its original place
		if (this.parent) {
			this.parent.append(this.element);
		}

		dialog.hide();
	}
}

// Run on all dialogs
const elements = document.querySelectorAll('[data-init="dialog"]');

elements.forEach(element => {
	const options =
		(element.dataset.dialogOptions ? JSON.parse(element.dataset.dialogOptions) : null) || {};
	const dialog = new Dialog();

	dialog.show(element, options);
});

export default Dialog;
